import React from 'react';
import {
    Header,
    Grid, Segment, Tab, Responsive
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import CreateQuestion from './CreateQuestion/CreateQuestion';
import PollInfo from './PollInfo/PollInfo';
import AdminPollPreview from './PollPreview/AdminPollPreview';
import AddExistingQuestion from './CreateQuestion/AddExistingQuestion';


export default class PollPreviewTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


        };
    }


    render() {
        const panes = [
            {
                menuItem: 'Osnovne informacije',
                render: () => (<Tab.Pane as={Responsive}>
                    <PollInfo />
                </Tab.Pane>)
            },
            {
                menuItem: 'Prikaz pitanja',
                render: () => (<Tab.Pane as={Responsive}>
                    <AdminPollPreview />
                    {/* {localStorage.getItem('student')?<StudentPollDetailes />:<AdminPollPreview />} */}
                </Tab.Pane>)
            },


        ];
        if (localStorage.getItem('edit') === 'enable') {
            panes.push({
                menuItem: 'Kreiranje novog pitanja',
                render: () => (<Tab.Pane as={Responsive}>
                    <CreateQuestion />
                </Tab.Pane>)
            });
            panes.push({
                menuItem: 'Dodavanje postojećeg pitanja',
                render: () => (<Tab.Pane as={Responsive}>
                    <AddExistingQuestion />
                </Tab.Pane>)
            });
        }
        return (
            <div>

                <h1>Detalji</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Naziv: {JSON.parse(localStorage.getItem('poll')).pollName}
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollPreviewTabs/PollPreviewTabs.js